import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box, FormControl, FormHelperText, InputAdornment, inputBaseClasses, InputLabel, Select, selectClasses, Stack, styled } from '@mui/material';
import { Button } from '@elements/button';
import { CheckboxField } from '@elements/form/fields/checkbox-field';
import { TextField } from '@elements/form/fields/text-field';
import { pxToRem } from '@themes';
var Puller = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: pxToRem(20),
    height: pxToRem(3),
    backgroundColor: theme.colors.frenchGray,
    borderRadius: pxToRem(2),
    position: 'absolute',
    top: pxToRem(12),
    opacity: '50%',
    left: "calc(50% - ".concat(pxToRem(10), ")")
  };
});
var DrawerContainer = styled(Box)(function (_ref2) {
  var theme = _ref2.theme,
      $searchListField = _ref2.$searchListField;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: $searchListField ? 'flex-start' : 'center',
    flexDirection: 'column',
    padding: "".concat(theme.spacing(5), " 0 ").concat(theme.spacing(5), " 0"),
    height: $searchListField ? '80vh' : 'auto'
  };
});
var StyledTextField = styled(TextField)(function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  return _ref4 = {}, _defineProperty(_ref4, "& .".concat(inputBaseClasses.input), {
    height: theme.typography.pxToRem(44)
  }), _defineProperty(_ref4, '& .MuiInputAdornment-positionStart', {
    padding: "".concat(pxToRem(22), " 0 ").concat(pxToRem(22), " ").concat(pxToRem(12))
  }), _defineProperty(_ref4, '& .MuiInputAdornment-positionEnd', {
    padding: "".concat(pxToRem(20), " 0 ").concat(pxToRem(20), " ").concat(pxToRem(12))
  }), _ref4;
});
var ItemsContainer = styled(Stack)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    padding: theme.spacing(0, 1.5),
    gap: pxToRem(8),
    width: '100%'
  };
});
var StyledFormControl = styled(FormControl)(function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  var styles = {
    display: fullWidth && 'flex',
    maxWidth: '100%'
  };
  return styles;
});
var StyledInputLabel = styled(InputLabel)(function (_ref7) {
  var theme = _ref7.theme;
  var styles = {
    position: 'relative',
    transform: 'unset',
    transformOrigin: 'unset',
    maxWidth: '100%',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
    fontWeight: 400,
    color: theme.colors.comet,
    letterSpacing: '-0.0015em',
    display: 'block',
    whiteSpace: 'unset',
    paddingLeft: theme.spacing(0.5),
    paddingBottom: theme.spacing(1),
    '&.Mui-focused': {
      color: theme.colors.comet
    },
    '&.Mui-error': {
      color: theme.colors.comet
    }
  };
  return styles;
});
var StyleFromHelperWrapper = styled(Box)(function (_ref8) {
  var theme = _ref8.theme;
  var styles = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    marginTop: theme.spacing(0.5),
    fontSize: pxToRem(12),
    lineHeight: pxToRem(14)
  };
  return styles;
});
var StyledCheckBox = styled(CheckboxField)(function (_ref9) {
  var theme = _ref9.theme;
  var styles = {
    marginLeft: pxToRem(11)
  };
  return styles;
});
var StyledFormHelperErrorText = styled(FormHelperText)(function (_ref10) {
  var theme = _ref10.theme;
  var styles = {
    '&&': {
      color: theme.colors.bitterSweet,
      display: 'block',
      padding: theme.spacing(0, 2),
      margin: 'unset',
      maxWidth: '100%'
    }
  };
  return styles;
});
var StyledSelectBase = styled(Select, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isApplied' && prop !== 'basicSelect' && prop !== 'bottomLabel';
  }
})(function (_ref11) {
  var _styles;

  var theme = _ref11.theme,
      isApplied = _ref11.isApplied,
      basicSelect = _ref11.basicSelect;
  var styles = (_styles = {
    border: 'none',
    borderRadius: pxToRem(14),
    overflow: 'hidden'
  }, _defineProperty(_styles, "& .".concat(selectClasses.multiple), {
    paddingRight: 0
  }), _defineProperty(_styles, "& .".concat(selectClasses.select), {
    boxSizing: 'border-box',
    height: theme.typography.pxToRem(48),
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(20),
    fontWeight: 500,
    letterSpacing: '-0.003em',
    color: basicSelect ? theme.colors.mineShaft : isApplied ? theme.colors.white : theme.colors.mineShaft,
    padding: "".concat(theme.spacing(1.75, 6.25, 1.75, 2), " !important"),
    position: 'relative',
    backgroundColor: basicSelect ? theme.colors.whisper : isApplied ? theme.colors.funGreen : theme.colors.whisper
  }), _defineProperty(_styles, '&.Mui-disabled', {
    '& .MuiSelect-icon': {
      display: 'none'
    }
  }), _defineProperty(_styles, '& .MuiOutlinedInput-notchedOutline', {
    border: 'none'
  }), _styles);
  return styles;
});

var SelectPaperStyles = function SelectPaperStyles(isMobile, theme, multiple) {
  var styles = {
    transform: 'translateY(4px)',
    borderRadius: pxToRem(12),
    display: 'block'
  };
  return styles;
};

var SelectMenuStyles = function SelectMenuStyles(theme, scrollable) {
  return {
    width: !scrollable ? pxToRem(258) : '100%',
    '&.MuiMenu-list': {
      padding: 0
    },
    li: {
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(1, 1.5),
      borderRadius: pxToRem(12),
      ':last-child': {
        marginBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(0)
      },
      '&.Mui-selected': {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.white
      }
    }
  };
};

var StyledButton = styled(Button, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'active' && prop !== '$isDefault';
  }
})(function (_ref12) {
  var theme = _ref12.theme,
      active = _ref12.active,
      $isDefault = _ref12.$isDefault;
  return {
    display: $isDefault ? 'none' : 'inline-flex',
    justifyContent: 'flex-start',
    backgroundColor: active ? theme.colors.white : undefined,
    ':hover': {
      backgroundColor: theme.colors.frenchGray
    }
  };
});
var StyledInputAdornment = styled(InputAdornment)(function (_ref13) {
  var theme = _ref13.theme,
      disabled = _ref13.disabled;
  var styles = {
    display: disabled ? 'none' : 'flex',
    position: 'absolute',
    right: 0,
    cursor: 'pointer',
    padding: "".concat(pxToRem(24), " ").concat(pxToRem(24), " ").concat(pxToRem(24), " 0"),
    backgroundColor: theme.colors.whisper
  };
  return styles;
});
var StyledBox = styled(Box)(function (_ref14) {
  var theme = _ref14.theme;
  var styles = {
    height: pxToRem(100),
    width: pxToRem(60),
    background: 'linear-gradient(270deg, #FFFFFF 61.47%, rgba(255, 255, 255, 0) 100%)',
    borderRadius: pxToRem(35)
  };
  return styles;
});
var SelectFooter = styled(Box)(function (_ref15) {
  var theme = _ref15.theme;
  var styles = {
    width: '100%',
    backgroundColor: theme.colors.white,
    borderTop: "".concat(pxToRem(1), " solid ").concat(theme.colors.catskillWhite)
  };
  return styles;
});
var SelectHeader = styled(Box)(function (_ref16) {
  var theme = _ref16.theme;
  var styles = {
    width: '100%',
    backgroundColor: theme.colors.white
  };
  return styles;
});
var ScrollHandler = styled(Box)(function (_ref17) {
  var theme = _ref17.theme,
      multiple = _ref17.multiple;
  var styles = {
    maxHeight: pxToRem(216),
    overflowY: 'auto'
  };

  if (!multiple) {
    styles = {};
  }

  return styles;
});
export { DrawerContainer, ItemsContainer, Puller, ScrollHandler, SelectFooter, SelectHeader, SelectMenuStyles, SelectPaperStyles, StyledBox, StyledButton, StyledCheckBox, StyledFormControl, StyledFormHelperErrorText, StyledInputAdornment, StyledInputLabel, StyledSelectBase, StyledTextField, StyleFromHelperWrapper };